import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { fechaIsoALocal } from './fecha-local.util';

/**
 * Adaptador de fechas de Angular Material que lee 'YYYY-MM-DD' como día de calendario en la
 * hora local. El NativeDateAdapter lo toma como medianoche UTC y en Argentina los selectores
 * mostraban un día menos (ej.: la NC con fecha 28/09 aparecía como 27/9).
 * Cualquier otro valor (fechas con hora, objetos Date) se lee igual que antes.
 */
@Injectable()
export class LocalDateAdapter extends NativeDateAdapter {
  override deserialize(value: unknown): Date | null {
    if (typeof value === 'string') {
      const fecha = fechaIsoALocal(value);
      if (fecha) return fecha;
    }
    return super.deserialize(value);
  }
}
